import { Component, Input, OnInit } from '@angular/core';
import { Avatar } from './avatar.interface';
import { twMerge } from 'tailwind-merge';
import { HttpClient } from '@angular/common/http';
import { environment } from '@projects/adir/src/environments/environment';
import { UserPanelComponent } from '@shared/src/lib/components/user-panel/user-panel.component';

@Component({
  selector: 'lib-avatar',
  standalone: true,
  imports: [UserPanelComponent],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.css',
})
export class AvatarComponent implements OnInit {
  defaultClass = 'avatar';

  @Input() src: string;
  @Input() alt: string;
  @Input() size: Avatar.Sizes = 'small';
  @Input() classes = '';
  constructor(private readonly http: HttpClient) { }

  ngOnInit(): void {
    this.classes = twMerge(this.classes, this.defaultClass, this.size);
    this.getProfile(environment.apiConfig.uri);
  }

  getProfile(url: string) {
    this.http.get(url).subscribe((profile) => {
      console.log('profile :>> ', profile);
    });
  }
}
